angular.module("pe4h").service("LoginService", ['$state', function ($state) {
    var _redirectSignUp = function(backURL){
        redirectAuthenticate('signup', backURL);
    }
    
    var _redirectLogIn = function(backURL){
        redirectAuthenticate('login', backURL);
    }

    function redirectAuthenticate(authState, backURL) {
        var currentUrl = backURL || '';
        var projectUID = null;
        if(currentUrl.includes("/rfp/")){
            projectUID = currentUrl.split("/rfp/")[1];
        }
        if(projectUID){
            $state.go(authState, { "next" : "project", "params":JSON.stringify({"uid":projectUID})});
        }else{
            $state.go(authState, {});
        }
    }
            
    return {
        redirectSignUp: _redirectSignUp,
        redirectLogIn: _redirectLogIn
    }
}]);